export default __webpack_public_path__ + "static/media/05.bf45ccc5.jpg";